/**
 * Authentication state enum
 * Represents the possible states of user authentication
 */
export const AuthState = {
  /** Initial state while checking authentication */
  LOADING: 'loading',
  /** User is signed in but email is not verified */
  EMAIL_UNVERIFIED: 'email_unverified',
  /** No user is signed in */
  LOGGED_OUT: 'logged_out',
  /** User is fully authenticated with verified email */
  AUTHENTICATED: 'authenticated',
  /** Admin user requires MFA verification */
  MFA_REQUIRED: 'mfa_required'
} as const;

export type AuthStateType = (typeof AuthState)[keyof typeof AuthState];
